<template>
  <span class="edinput-container my-0 w-100">
    <label ref="popLabel" @click="mkEditable"
           @mouseover="mkHovered"
           data-kt-menu-permanent="true"
           data-kt-menu-trigger="click"
           :data-kt-menu-placement="placement"
           data-kt-menu-static="true"
           class="edinput-label cursor-pointer d-inline-flex flex-wrap gap-1"
    >
      <!--<span class="edinput-edit rounded border border-1"> <i class="fa fa-pencil-alt"/></span>-->
      <span v-if="hyperlink && value" @click="openHyperlink" data-hyperlink="1" class="edinput-edit rounded border border-1">
        <i data-hyperlink="1" class="fa fa-external-link-alt text-primary"/>
      </span>

      <!--      &nbsp;-->
      <slot name="label">
        <div v-if="type === 'check'">
          <span v-if="label">{{ label }}</span>
          <span v-else><yes-no :ans="value"/></span>
        </div>
        <div v-else-if="type === 'user_select'">
          <div v-for="v in value">{{ v.email }}</div>
        </div>
        <div v-else-if="type === 'select' && conf.multiple">
          <span v-for="v in label" class="pending">{{ v.name }}</span>
        </div>
        <span class="" v-else>
          <span v-if="label">{{ label }}</span>
          <span v-else>
            <span v-if="columnWidth && value && (value.length > columnWidth)">{{ value.substring(0, columnWidth) }}...</span>
            <span v-else>{{ value }}</span>
<!--            {{ label ? label : value }}-->
          </span>
        </span>
      </slot>
    </label>
    <!--         :class="[absClasses, {'edit-left': position == 'left', 'edit-far-left': position == 'far-left', 'edit-top': vertPosition == 'top'}]"-->
    <!--         style="width: 200px"-->
    <!--    v-show="edit"-->
    <div v-if="editable" v-kt-menu ref="popContent"
         :class="popWrapperClasses"
         data-kt-menu="true" data-kt-menu-static="true">
      <div v-if="hovered" class="menu-item edinput-input m-1">
        <select2
            ref="selector"
            v-if="type==='select' && config"
            :tags="tags"
            :value="value"
            @change="emitSelectValue"
            :options="options"
            :config="config"
        />
        <!--        <treeselect-->
        <!--            v-if="type==='select'"-->
        <!--            class="fw-bold mb-1"-->
        <!--            :name="name"-->
        <!--            :placeholder="placeholder"-->
        <!--            :multiple="conf.multiple"-->
        <!--            :clearable="conf.clearable"-->
        <!--            :searchable="conf.searchable"-->
        <!--            :disabled="conf.disabled"-->
        <!--            :open-direction="conf.openDirection"-->
        <!--            :open-on-click="conf.openOnClick"-->
        <!--            :open-on-focus="conf.openOnFocus"-->
        <!--            :clear-on-select="conf.clearOnSelect"-->
        <!--            :close-on-select="conf.closeOnSelect"-->
        <!--            :always-open="conf.alwaysOpen"-->
        <!--            :append-to-body="conf.appendToBody"-->
        <!--            :options="options"-->
        <!--            :limit="conf.limit"-->
        <!--            :max-height="conf.maxHeight"-->
        <!--            :value="value"-->
        <!--            @input="emitSelectValue"-->
        <!--            :normalizer="normalizer"-->
        <!--        />-->
        <div v-else-if="type==='check'" class="">
          <div class="form-check form-check-custom form-check-solid">
            <input type="checkbox" :checked="value" @input="emitValue($event.target.checked)" class="form-check-input">
            <label for="" class="form-check-label">Yes</label>
          </div>
        </div>
        <select2
            v-else-if="type==='user_select' && config"
            :disabled="disabled"
            ref="userSelector"
            v-model="changedValue"
            :options="options"
            :template="userTemplate"
            :selection-template="userSelectionTemplate"
            :config="{
              ...config,
              ajax: config.internal ? undefined : {
                paginated: true,
                url: genUrl('users', null,  'search'),
                term: 'query',
              }
            }"
        />
        <!--        <user-selector v-else-if="type==='user_select'" :title="userSelectTitle" v-model="changedValue"/>-->
        <div v-else-if="type==='date'" class="mb-2">
          <date-picker v-model="changedValue"
                       format="DD/MM/YYYY"
                       :clear-button="true"
                       :typeable="false"
                       :inline="false"
                       :calendar-class="calenderClass"
                       input-class="form-control form-control-sm"
          />
        </div>
        <div v-else-if="type==='textarea'" class="mb-2">
          <textarea
              ref="textinput"
              class="form-control form-control-solid form-control-sm mb-2 h-125px"
              :id="name"
              :value="value"
              @input="emitValue($event.target.value)"
              @keyup.esc="closeEdit"
              :disabled="disabled"
              :columnWidth="columnWidth"
          ></textarea>
        </div>
        <input
            v-else
            ref="ebinput"
            :type="type"
            class="form-control form-control-solid form-control-sm mb-2"
            :id="name"
            :value="value"
            @input="emitValue($event.target.value)"
            @keyup.enter="doUpdate"
            @keyup.esc="closeEdit"
            :disabled="disabled"
        />
        <div class="dm-treeselect-btn d-flex">
          <button type="button" v-if="!isHide" @click="doUpdate" class="btn btn-primary">Save</button>
          <button type="button" @click="closeEdit" class="btn btn-secondary">Cancel</button>
        </div>
      </div>
    </div>
  </span>
</template>
<!--@blur="edit = false"-->

<script>
import UserSelector from "@cc/includes/UserSelector.vue";

const config = {
  multiple: false,
  clearable: true,
  searchable: true,
  disabled: false,
  openDirection: 'top',
  openOnClick: true,
  openOnFocus: false,
  clearOnSelect: false,
  closeOnSelect: true,
  alwaysOpen: false,
  appendToBody: false,
  limit: 10,
  maxHeight: 200,

  id: 'id',
  label: 'label',
}

export default {
  components: {UserSelector},
  props: {
    type: {
      default: "text"
    },
    index: null,
    hyperlink: "", //http|email
    link: null,
    editable: {
      default: true,
    },
    value: {
      type: String | Number,
      default: '',
      required: false,
    },
    placeholder: {
      type: String | Number,
      default: 'Select One'
    },
    name: {
      type: String | Number,
      required: false,
    },
    label: {
      type: String | Number,
      required: false,
    },
    // context object to update
    context: {
      default: null,
    },
    // pass the root context
    contextRoot: {
      default: null,
    },
    update: {
      default() {
      }
    },
    disabled: {
      default: false,
    },
    isHide: false,
    config: {
      type: Object,
      default: null,
    },
    tags: {
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    userSelectTitle: {
      type: String,
      default: ""
    },
    placement: {
      type: String,
      default: "bottom-end"
    },
    calendarPlacement: {
      type: String | Array,
      default: "top"
    },
    columnWidth: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      edit: false,
      selectVal: null,
      // selectTick: 0,
      changedValue: undefined,
      // absClasses: "card m-1 p-2 position-absolute z-index-9",
      rkey: _.random(true),
      ktm: null,
      hovered: false,
      hyperClicked: false,
      listeners: false,
    }
  },
  computed: {
    conf() {
      if (!this.config) return {...config};

      return {...config, ...this.config}
    },
    popWrapperClasses(){
      let classes_ = "menu menu-sub menu-sub-dropdown menu-column menu-rounded"

      // if(this.type == 'textarea'){
      //   classes_ += " w-275px"
      // }else{
      //   classes_ += " w-200px"
      // }
      classes_ += " w-275px"

      return classes_
    },
    calenderClass() {
      let classes = []
      if (Array.isArray(this.calendarPlacement)) {
        classes = this.calendarPlacement
      } else {
        classes = [this.calendarPlacement]
      }

      let finalized = []
      classes.forEach(cls => {
        let class_ = ''
        switch (cls) {
          case 'top':
            class_ = 'bottom-8'
            break
          case 'bottom':
            class_ = 'top-0'
            break
          case 'left':
            class_ = 'end-0'
            break
          case 'right':
            class_ = 'start-0'
            break
          default:
            class_ = cls
        }
        finalized.push(class_)
      })

      return finalized
    },
  },
  watch: {
    value: {
      handler(val) {
        this.valueRecalced()
      }
    }
  },
  created() {
    this.valueRecalced()
  },
  mounted() {
    // this.docu = document.addEventListener('click', (elem) => {
    //   console.log(elem, this.$el.contains(elem.target))
    //   // detects if the click is within this.$el
    //   if(!this.$el.contains(elem.target)){
    //     this.closeEdit()
    //   }
    // })
  },
  beforeDestroy() {
    this.killKTM()
    // this.docu = null
  },
  methods: {
    openHyperlink(){
      let link_ = this.value

      // internal route or email
      if(this.link) {
        link_ = this.link;

        // internal route
        (typeof this.link === 'object')
        {
          return this.$router.push(link_)
        }
      }

      if(this.hyperlink == 'email'){
        window.location.href = `mailto:${link_}`;
      }
      else if(this.hyperlink == 'http'){
        
        const url = this.value.startsWith('http') ? link_ : `//${link_}`
        window.open(url, '_blank');
      }
    },
    valueRecalced() {
      if (this.type === 'user_select') {
        this.changedValue = this.value || []
      }
      if (this.type === 'date') {
        this.changedValue = this.value ? new Date(this.value) : null
      }
    },
    closeEdit() {
      this.edit = false
      this.ktm.hide()

      // this.killKTM()
    },
    killKTM() {
      if (this.ktm) {
        this.ktm.off("kt.menu.dropdown.shown")
        this.ktm.off("kt.menu.dropdown.hide")
        this.ktm.destroy()
        KTUtil.data(this.ktm.triggerElement).remove("menu")
        this.listeners = false
      }
    },
    mkHovered() {
      if (!this.editable) return;
      this.hovered = true

      if(!this.ktm){
        this.ktm = KTMenu.getInstance(this.$refs.popContent)
      }
      // console.log(this.ktm)
      // this.$nextTick(() => {
      // })
    },
    mkEditable(evt) {
      console.log(evt)
      if (!this.editable) return;

      this.ktm.off("kt.menu.dropdown.show")

      // ignore cuttr readMore element click, use 'a' to filter
      // ignore data-hyperlink clicks
      const preventOpening = evt.target.tagName.toLowerCase() === "a" || evt.target.hasAttribute('data-hyperlink')

      if(preventOpening){
        this.hyperClicked = true
        // console.log(evt.target)
        // console.log(this.ktm)
        // this.ktm.hide()
        this.ktm.on("kt.menu.dropdown.show", (evt) => {
          console.log('HYPER_PREVENT_OPEN')
          return false //prevent opening
        })
        return;
      }
      this.hyperClicked = false

      this.rkey = _.random(true)
      this.edit = true
      // this.killKTM()
      // if (this.ktm) return

      if (this.listeners) return;

      this.ktm.on("kt.menu.dropdown.shown", (pElem) => {
        console.log('ktm_edit_shown')
        //mainly to give select2 some time to calculate open position
        this.$nextTick(() => {
          if (this.type === 'text') {
            this.$refs.ebinput.focus()
          }
          if (this.type === 'textarea') {
            this.$refs.textinput.focus()
          }
          if (this.type === 'select') {
            this.$refs.selector.focus()
          }
          if (this.type === 'user_select') {
            this.$refs.userSelector.focus()
          }
        })
      })
      this.ktm.on("kt.menu.dropdown.hide", (pElem) => {
        if (this.edit) return false
      })
      this.listeners = true
      //render ktMenu instance on hover
      this.$nextTick(() => {
      })
      setTimeout(() => {
        // window.KTMenu.createInstances()
        // this.ktm.show()
        // this.ktm.show()
        // setTimeout(() => this.ktm.show(), 1000)
      }, 100)

    },
    emitValue(value) {
      this.changedValue = value
      return
      this.$emit('input', value)
    },
    emitSelectValue(value) {
      // console.log('ems', value)
      // this.selectTick++
      const val_ = value === undefined ? null : value;
      this.changedValue = val_
      this.$emit('change', value)
      // if(this.selectTick < 2) return;
      return
      this.$emit('input', val_)
      this.doUpdate(val_)
    },
    normalizer(node) {
      return {
        id: node[this.conf.id],
        label: node[this.conf.label],
      }
    },
    doUpdate: async function () {
      let updateValue = typeof this.changedValue === 'undefined' ? this.value : this.changedValue
      if(this.type == 'date'){
        updateValue = this.momentMixin(updateValue, 'YYYY-MM-DD')
      }
      console.log(updateValue)
      try {
        await this.update(this.name, updateValue, this.context, {index: this.index, contextKey: this.contextKey})
        this.closeEdit()
      } catch (e) {
        throw e
      }
    },
    dateOpened() {
      // setTimeout(() => {
      //    KTMenu.updateDropdowns()
      //    this.ktm.update()
      //  }, 3000)
    },
    dateClosed() {
      // console.log(`xaxa`)
    },
  },
}
</script>